// export const base_url = "https://clayo-api-qa.azurewebsites.net/api";
// export const base_url = "https://applications.greenmanopen.com/api";
// export const base_url = "https://mobileapi.clayo.io/api"
// export const base_url = "http://localhost:3001/api";
export const base_url = "https://applications.greenmanopen.com/api";
// export const base_url = "https://nice-werewolf-adequate.ngrok-free.app/api";
